import { useEffect, useRef } from "react";
import { Oneko } from "lots-o-nekos";

const DB_BASE = "https://raw.githubusercontent.com/raynecloudy/oneko_db/refs/heads/master";

const buildSourceUrl = (name) => {
  const safe = name && name.length ? name : "default";
  return `${DB_BASE}/${encodeURIComponent(safe)}.png`;
};

const readSettings = () => {
  const count = Number(sessionStorage.getItem("curiosityPetCount")) || 1;
  const speed = Number(sessionStorage.getItem("curiositySpeed")) || 10;
  const size = Number(sessionStorage.getItem("curiositySize")) || 32;
  return {
    enabled: sessionStorage.getItem("curiosityEnabled") === "true",
    pet: sessionStorage.getItem("curiosityPet") || "default",
    count: Math.min(5, Math.max(1, count)),
    behavior: sessionStorage.getItem("curiosityBehavior") || "follow",
    speed: Math.min(40, Math.max(2, speed)),
    size: Math.min(96, Math.max(16, size)),
  };
};

const CuriosityManager = () => {
  const instancesRef = useRef([]);
  const mouseHandlerRef = useRef(null);
  const wanderTimerRef = useRef(null);

  const teardown = () => {
    if (mouseHandlerRef.current) {
      window.removeEventListener("mousemove", mouseHandlerRef.current);
      mouseHandlerRef.current = null;
    }
    if (wanderTimerRef.current) {
      clearInterval(wanderTimerRef.current);
      wanderTimerRef.current = null;
    }
    instancesRef.current.forEach((inst) => {
      try {
        if (inst && inst.element && inst.element.parentNode) {
          inst.element.parentNode.removeChild(inst.element);
        }
      } catch (e) {}
    });
    instancesRef.current = [];
  };

  const setup = () => {
    teardown();
    const settings = readSettings();
    if (!settings.enabled) return;

    const sourceUrl = buildSourceUrl(settings.pet);

    for (let i = 0; i < settings.count; i++) {
      try {
        const inst = new Oneko({
          source: sourceUrl,
          x: Math.random() * window.innerWidth,
          y: Math.random() * window.innerHeight,
          speed: settings.speed,
          size: settings.size,
        });
        instancesRef.current.push(inst);
      } catch (err) {
        console.log("Failed creating pet", err);
      }
    }

    if (settings.behavior === "follow") {
      const handler = (e) => {
        instancesRef.current.forEach((inst, idx) => {
          const offset = idx * (settings.size * 0.75);
          try {
            inst.setTarget(e.clientX + offset, e.clientY);
          } catch (e2) {}
        });
      };
      mouseHandlerRef.current = handler;
      window.addEventListener("mousemove", handler);
    } else if (settings.behavior === "wander") {
      const tick = () => {
        instancesRef.current.forEach((inst) => {
          try {
            inst.setTarget(
              Math.random() * window.innerWidth,
              Math.random() * window.innerHeight
            );
          } catch (e) {}
        });
      };
      tick();
      wanderTimerRef.current = setInterval(tick, 3000);
    }
  };

  useEffect(() => {
    setup();
    const onUpdate = () => setup();
    window.addEventListener("curiosity:update", onUpdate);
    return () => {
      window.removeEventListener("curiosity:update", onUpdate);
      teardown();
    };
  }, []);

  return null;
};

export default CuriosityManager;
